// extracted by mini-css-extract-plugin
module.exports = {"inputbAR":"MobileSearch-module__inputbAR___wHFzc","searchIcon":"MobileSearch-module__searchIcon___xOQhG"};